import React from 'react';

import { jiraServiceManagementIcon } from '@atlaskit/logo/raw-icons';

/** Decorative product icon accompanying the Jira Service Management attribution name. */
export const JiraServiceManagementAttributionIcon = (): React.JSX.Element => (
	<img src={jiraServiceManagementIcon} alt="" width={16} height={16} />
);
